import { render, staticRenderFns } from "./AssignReportForm.vue?vue&type=template&id=3dceb98e&lang=pug&"
import script from "./AssignReportForm.vue?vue&type=script&lang=ts&"
export * from "./AssignReportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports